import DataTable, { createTheme } from "react-data-table-component";
import { useState,useEffect,useMemo, Fragment } from "react";

import MoreVert from '@mui/icons-material/MoreVert';
import { ManageSearchRounded,Clear,Print } from "@mui/icons-material";
import { Modal,IconButton,Button, capitalize } from "@mui/material";
import { Backdrop,Fade,Typography} from "@mui/material";

import { modalstyle,tablestyle,parseToLink,concurrecySort,dateSort } from "./Style";
import { TextField,Box } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { blue,blueGrey,green } from "@mui/material/colors";
import { AvvisoCard } from "./AvvisoCard";
import { Divider, Grid2 } from '@mui/material';
import ENEAlogo from './ENEAlogo';
import { ENEA_GEST_API_URL } from './Statics';


const baseurl= ENEA_GEST_API_URL;
//const baseurl = "https://dati.enea.it/gest/catalog/"
const avvisiurl = baseurl+"avvisi/search";

// documentation 19/3/2025

// elenco_avvisi_tabellare
// ${API_URL}avvisi/search?page=${currentPage}&per_page=${recordsPerPage}&q=${searchQuery}${flagScaduti}


// https://react-data-table-component.netlify.app/?path=/story/custom-styles-compact-grid--compact-grid&globals=backgrounds.grid:!false

createTheme(
	'ENEA',
	{
		text: {
			primary: blue[700],
			secondary: blue[500],
		},
		background: {
			default: '#ffffff',
		},
		context: {
			background: blue[900],
			text: '#aaaaaa',
		},
		divider: {
			default: '#073642',
		},
		button: {
            default: '#2aa198',
			hover: 'rgba(0,0,0,.08)',
			focus: 'rgba(255,255,255,.12)',
			disabled: 'rgba(255, 255, 255, .34)',
		},
		sortFocus: {
			default: '#2aa198',
		},
	},
	'dark',
);


const TableAvvisi =({showid,mindate,maxdate})=>{

    const [json,setJson]=useState([]);
    const [busy,setBusy]=useState(false);
    const [page,setPage]=useState(0);
    const [details,setDetails]=useState();
    const [openDetails,setShowDetails]=useState(false);
    const [filterText,setFilterText]=useState('');
    const [scaduti,setScaduti]=useState(false);
    const [find,setFind]=useState([]);

    /* Search */
    useEffect(()=>{
      console.log("search on esiti "+filterText);
      
    },[filterText])
    
    const subHeaderComponentMemo = () => {
    const handleClear = () => {
        setFilterText("");
    };
    const handleChange = (val) => {
      setFilterText(val);
    };

    const getDetail = (url)=>{
      //setBusy(true);
      fetch(url,{
          method:'GET'
      }).then(resp=>resp.json())
        .then(j=>{
          //setBusy(false);
          console.log(j);
          setDetails(j);
          setShowDetails(true);
        }
      ).catch(err=>{console.log("err")})
    }
    return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormControlLabel
        label="Visualizza scaduti"
        control={<Checkbox onChange={(e)=>setScaduti(e.currentTarget.checked)} />}
      />
      <ManageSearchRounded sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
     
      <TextField fullWidth 
              size="small" 
              variant='outlined' 
              value={filterText} 
              label="Ricerca full-text" 
              onChange={(e)=>handleChange(e.target.value)}/>
      <IconButton  aria-label="clear" aria-roledescription="clear button" sx={{color:blue[800]}} onClick={()=>handleClear()}>
        <Clear/>
      </IconButton>
    </Box>
    );
  }; 

  const getDetail = (url)=>{
    setBusy(true);
    fetch(url,{
        method:'GET'
    }).then(resp=>resp.json())
      .then(j=>{
        setBusy(false);
        if(j.length>0){
          setDetails(j[0]);
          setShowDetails(true);    
        }else{
          console.log("too much elements "+j);
        }
      }
    ).catch(err=>{console.log("err")})
  }
  
  const columns = [
  {
    name: <Typography variant="body2">Scadenza avviso</Typography>,
    selector: row => new Date(row.scadenza_selezione).toLocaleDateString()||'-',
    sortFunction: (a,b)=>new Date(a.scadenza_selezione)-new Date(b.scadenza_selezione),
    sortable: true,
    width:"140px",  
  },
  {
    name: <Typography variant="body2">Identificativo</Typography>,
    selector: row => row.id,
    sortable: true,
    width:"120px",
  },
  {
    name: <Typography variant="body2">Oggetto appalto</Typography>,
    selector: row => row.oggetto_appalto,
    sortable: true,
    grow:true,
    wrap:true,
    width:"200px",
  },
  {
    name: <Typography variant="body2">Procedura</Typography>,
    selector: row => row.procedura_nome,
    sortable: true,
    grow:true,
    wrap:true,
    width:"200px",
  }, 
  {
    name: <Typography variant="body2">Importo netto</Typography>,
    selector: row =>  new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(row.importo_base_asta),
    sortFunction: (a,b)=>a.importo_base_asta-b.importo_base_asta,
    sortable: true,
    width:"150px",
  },
  {
  name: <Typography variant="body2">Dettagli</Typography>,
  selector: row => {
        return (
          <Fragment>
          <IconButton aria-label="detail" aria-roledescription="get details" sx={{textWrap:'auto',color:blue[800]}} onClick={()=>getDetail(parseToLink(row.dettaglio))}>
            <MoreVert/><Typography variant="body2" component="span">apri dettagli</Typography>
          </IconButton>
          </Fragment>
        );
    },
  sortable: false,
  grow:true,
  
  minWidth:"150px",
},];

 /* filter effect */
 useEffect(()=>{
  //let rex = filterText.trim().replace(" ",".+");
  if(filterText.length>0){
    let regex = new RegExp(filterText.trim().replaceAll(" ",".+"), "i");
    const find = json.filter( singlerow => {
      return Object.values(singlerow).filter( v => {
        if(typeof v === 'string' || v instanceof String)  
          return v.match(regex)!==null;
        return false;
      }).length>0
    }).map( o =>o);
    setFind(find);
  }else{
    setFind(json);
  }
},[json,filterText]);


const myfetch = (url,page,arraydest,sca,cb)=>{
        let turl = new URL(url);
        
        if((page!==undefined)&&(page!==0)){
          turl.searchParams.set("page",page);
        } else{
          turl.searchParams.set("page",1);
        }
        turl.searchParams.set("scaduti",(sca===true)?1:0);
        turl.searchParams.set("per_page",99999);
        setBusy(true);
        fetch(turl,{
          method:'GET'
        }).then(resp=>resp.json())
        .then(j=>{
          arraydest.push(j.data);
          if(j.current_page<j.last_page){
            myfetch(url,j.current_page+1,arraydest,cb);
            setPage(j.current_page+1);
          } else {

            /* filter by min/max date if present */
            let filterdata = [];
            let tmpdata = [];
            
            if(mindate!==undefined){
              tmpdata = arraydest.flatMap(o=>o).filter(f=>new Date(f.scadenza_selezione)>=new Date(mindate));
            } else {
              tmpdata = (arraydest.flatMap(o=>o));
            }
            if(maxdate!==undefined){
              filterdata = (tmpdata.filter(fm=>new Date(fm.scadenza_selezione)<=new Date(maxdate)));
            }else{
              filterdata = (tmpdata);
            }

            setJson(filterdata);
            //setJson(arraydest.flatMap(o=>o));
            
            setBusy(false);
            cb(j);
          }
        }).catch(err=>{console.log("err")})
      };
      
      useEffect(()=>{
        myfetch(avvisiurl,0,[],scaduti,()=>{
          console.log("Avvisi finish");
          if(showid!=='')
            getDetail(parseToLink('/api/v1/avvisi/'+showid));
        });
      },[scaduti]);

    return (
    <Fragment>
      <DataTable 
        customStyles={tablestyle} 
        highlightOnHover 
        subHeader 
        subHeaderComponent={subHeaderComponentMemo()} 
        persistTableHead 
        theme="ENEA" 
        progressPending={busy}  
        ariaLabel="elenco avvisi" 
        columns={columns}
        data={json} 
        paginationComponentOptions={{
          rowsPerPageText:"Righe per pagina",
        }}
        pagination />
    
    {details!==undefined && (
        <Modal
        aria-labelledby="modal-detail-title"
        aria-describedby="modal-detail-description"
        open={openDetails}
        onClose={()=>setShowDetails(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
          timeout: 500,
        },
        
      }}
      >
        <Fade in={openDetails}>
        <Box sx={{ ...modalstyle, width: '88%', overflowY:'visible' }}>
          <Grid2 container sx={{justifyContent: "space-between",alignItems: "center",}} columns={2}>
            <Grid2 size={1}>
            
            <Typography variant="h1" sx={{fontSize:36}} id="modal-detail-title">
              <ENEAlogo/>
                Scheda di dettaglio avviso {details.id}
              </Typography>
            </Grid2>
            <Grid2 size={1} sx={{width:"fit-content"}} >
              <IconButton title="stampa scheda" ariaLabel="stampa scheda" color="primary" onClick={()=>{
                  window.print();
                }
                }>
                <Print sx={{width:50,height:50}} />
              </IconButton>
              <IconButton title="chiudi scheda" ariaLabel="chiudi scheda" color="primary" onClick={()=>setShowDetails(false)}>
                <Clear sx={{width:50,height:50}} />
              </IconButton>
            </Grid2>
            <Grid2 size={2}>
              <Typography variant="h2" sx={{fontSize:24}} component="div" id="modal-detail-description" >
                {details.oggetto_appalto}
              
              </Typography>
            </Grid2>
          </Grid2>
          
          <AvvisoCard 
            detail={details}
            handleclose={()=>setShowDetails(false)} 
          />
        </Box>  
        </Fade>
      </Modal>
    )}
    </Fragment>
    )
}

export default TableAvvisi;